export default function dateFix(date, format = 0) {
    if (!date) return '';
    switch (format) {
        case 0:
            return date.split('-').reverse().join('/');
        case 1:
            return `${['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'][date.split('-')[1] - 1]} ${date.split('-')[0]}`
        case 2:
            return date;
        default:
            return '';
    }
}